"use client";
import Link from "next/link";
import styles from "@/styles/menu.module.scss";
import Image from "next/image";
import { Category } from "./category-card";
import { removeSpacesFromString } from "_services/common.service";
import { cookingLoadingService } from "_services/loadingCooking.service";
import { event } from "@lib/ga";

export default function ComboCard(props: { 
  bannerCount:number,
  deal: Category,
  className?: string,
  comboId?: string
}) {
  const { deal, className, comboId } = props;

  // redirect to the deal URL when clicked
  // const urlLink = deal.categoryName.toLowerCase().includes("half") ? "/halfhalf" : `/menu?c=${encodeURIComponent(deal.categoryName)}`;
  const urlLink = `/menu/${encodeURIComponent(deal.categoryName)}`;

  return (
    <Link
      key={deal.categoryId}
      href={urlLink}
      id={comboId || `deal-${deal.categoryId}-link`}
      data-category={removeSpacesFromString(deal.categoryName)}
      onClick={() => {
        cookingLoadingService.loading(true)

        event({
          action: 'select_combo',
          category: 'engagement',
          label: `combo_${removeSpacesFromString(deal.categoryName)}_clicked`
        })
      }}
    >
      <div
        className={`${styles.comboCard} ${className}`}
      >
        <h3>{deal.categoryName}</h3>
        <Image src={deal?.categoryImageUrls?.[0]?.imageUrl || '/assets/images/placeholder.png'} width={300} height={200}
        onError={(e) => { (e.target as HTMLImageElement).src = '/assets/images/placeholder.png'; }} alt={deal.categoryName} />
      </div>
    </Link>
  );
}

